import { ofType } from 'redux-observable';
import type { Observable } from 'rxjs';
import { filter, map, mergeMap, takeUntil } from 'rxjs/operators';
import type { Action } from 'state/actions';
import { QuoteRequestFailed } from 'state/forms/actions/quote';
import { dashboardTileCreated } from 'state/quotes/dashboard/dashboard.actions';
import type { EpicWithThunk } from 'state/state.common';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

export function quoteRequestFailure$(
  action$: Observable<Action>,
  workspace: QuoteWorkspaceType,
  reconciliationId: string,
): Observable<QuoteRequestFailed> {
  switch (workspace) {
    case 'dynamic':
      return action$.pipe(
        ofType('QUOTE_REQUEST_FAILED'),
        filter(x => x.workspace === 'dynamic' && x.frontReconciliationId === reconciliationId),
      );
    case 'static':
      return action$.pipe(
        ofType('QUOTE_REQUEST_FAILED'),
        filter(x => x.workspace === 'static' && x.frontReconciliationId === reconciliationId),
      );
    default:
      throw new Error('not implemented for ' + workspace) as never;
  }
}

export function createTileEpic(): EpicWithThunk {
  return action$ => {
    return action$.pipe(
      ofType('DASHBOARD_TILE_CREATING'),
      mergeMap(tile =>
        action$.pipe(
          ofType('QUOTE_ACKED'),
          takeUntil(quoteRequestFailure$(action$, tile.workspace, tile.reconciliationId)),
          filter(ack => ack.frontReconciliationId === tile.reconciliationId),
          map(ack => dashboardTileCreated(ack.quoteId)),
        ),
      ),
    );
  };
}
